<template>
  <div class="page page-course-system">
    <ym-img class="page-course-system-banner"
            :src="require('@/assets/img/course_system/1.png')"
    />
    <div class="page-course-system-header">
      <block-title title="少年商学院课程体系" />
      <div class="page-course-system-header-title">
        经济·金融·创业·领导力
      </div>
      <div class="page-course-system-header-content">
        6-15岁青少年财商与领导力提升<br/>
        让孩子从小学会规划自己的人生
      </div>
      <ym-img class="page-course-system-img-2"
              :src="require('@/assets/img/course_system/2021/2.png')"
      />
    </div>

    <div class="page-course-system-learn-path">
      <block-title title="四大版块" />

      <div class="page-course-system-learn-path-block">
        <ym-img class="page-course-system-img-3"
                :src="require('@/assets/img/course_system/2021/3.png')"
        />
        <ym-img class="page-course-system-img-4"
                :src="require('@/assets/img/course_system/4.png')"
        />
        <div class="page-course-system-learn-path-block-content">
          从小的经济学思维启蒙<br/>
          孩子了解世界的全新视角
        </div>
        <ym-img class="page-course-system-img-5"
                :src="require('@/assets/img/course_system/2021/5.png')"
        />
        <router-link :to="{ name: 'Audio' }">
          <div class="page-course-system-learn-path-block-link-more">
            更多课程
            <ym-img class="img-link"
                    :src="require('@/assets/img/course_system/link.png')"
            />
          </div>
        </router-link>
      </div>
      <div class="page-course-system-learn-path-block">
        <ym-img class="page-course-system-img-6"
                :src="require('@/assets/img/course_system/2021/6.png')"
        />
        <div class="page-course-system-learn-path-block-content">
          从零用钱开始的家庭理财<br/>
          到银行、投资与汇率和通胀等<br/>
          从小建立正确的财富观
        </div>
        <ym-img class="page-course-system-img-7"
                :src="require('@/assets/img/course_system/2021/7.png')"
        />
        <router-link :to="{ name: 'CourseList' }">
          <div class="page-course-system-learn-path-block-link-more">
            更多课程
            <ym-img class="img-link"
                    :src="require('@/assets/img/course_system/link.png')"
            />
          </div>
        </router-link>
      </div>
      <div class="page-course-system-learn-path-block">
        <ym-img class="page-course-system-img-8"
                :src="require('@/assets/img/course_system/2021/8.png')"
        />
        <ym-img class="page-course-system-img-9"
                :src="require('@/assets/img/course_system/2021/9.png')"
        />
        <div class="page-course-system-learn-path-block-desc">
          <span>
            模拟创业，像CEO一样思考与行动发现自己优势、潜能，提升领导力
          </span>
          <router-link :to="{ name: 'CourseList' }">
            <div class="page-course-system-learn-path-block-link-more margin-auto">
              更多课程
              <ym-img class="img-link"
                      :src="require('@/assets/img/course_system/link.png')"
              />
            </div>
          </router-link>
        </div>
      </div>
      <div class="page-course-system-learn-path-block">
        <ym-img class="page-course-system-img-10"
                :src="require('@/assets/img/course_system/2021/10.png')"
        />
        <div class="page-course-system-learn-path-block-content">
          哲学启蒙让孩子探索自我<br/>
          TED演讲让孩子公共表达<br/>
          从小有规划能力并知道自己要什么<br/>
          奠定影响一生的核心竞争力
        </div>
        <ym-img class="page-course-system-img-11"
                :src="require('@/assets/img/course_system/2021/11.png')"
        />
      </div>
    </div>

    <div class="page-course-system-system-file">
      <block-title title="评估体系与档案" />
      <ym-img class="page-course-system-img-12"
              :src="require('@/assets/img/course_system/2021/12.png')"
      />
      <ym-img class="page-course-system-img-13"
              :src="require('@/assets/img/course_system/2021/13.png')"
      />
      <div class="page-course-system-system-file-content">
        学生在少年商学院平台选课上课，都将拥有作品集及与专属成长档案。这一未来升学留学的“新成绩单系统”，
        是少年商学院在引入国际MTC（能力素养成绩单联盟）评价体系，并融合中国学生核心素养的基础上，
        开发的一套智能评估系统。少年商学院获中国教育部认可承担该课题研究，未来还将与区块链技术相结合。
      </div>
    </div>

    <div class="page-course-system-recognize">
      <block-title title="学术声誉与认可" />
      <div class="page-course-system-recognize-container">
        <ym-img class="page-course-system-img-14"
                :src="require('@/assets/img/course_system/14.png')"
        />
        <div class="page-course-system-recognize-container-content">
          <div class="page-course-system-recognize-container-content-deco"></div>
          少年商学院获得了斯坦福、哈佛、哥大、剑桥等名校教育学院院长及创新教育大咖们的认可与鼓励，
          过去的教育探索案例，被收录进入世界创新教育专著<i>Design Thinking Live</i>。
          此外，少商还获得了中国教育部认可，并承担相关国家课题。
        </div>
      </div>
    </div>

    <ym-img class="page-course-system-img-15"
            :src="require('@/assets/img/course_system/15.png')"
    />
  </div>
</template>

<script>
  import BlockTitle from '@/pages/OurSystem/components/BlockHeader';

  export default {
    name: 'CourseSystem',
    metaInfo: {
      title: '课程体系',
    },
    components: {
      BlockTitle,
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @main-color: #45bfc0;

  .page-course-system {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: @size-large;
    background: @color-white;

    &-header {
      &-title {
        display: inline-block;
        color: @color-white;
        font-size: @font-size-base;
        height: 40px;
        line-height: 40px;
        padding: 0 16px;
        border-radius: 5px;
        background-color: #333;
        margin: 40px 0 0 67px;
      }
      &-content {
        box-sizing: border-box;
        padding: @size-base 0 @size-base 80px;
        color: @color-text-light;
        font-size: @font-size-base;
        line-height: 1.5;
      }
    }

    &-img-2 {
      margin: 0 25px 205px;
      display: block;
      width: 700px;
      height: 468px;
    }
    &-img-3 {
      margin: 64px 0 24px 60px;
      display: block;
      width: 252px;
      height: 70px;
    }
    &-img-4 {
      position: absolute;
      top: -118px;
      right: @size-large;
      display: block;
      width: 225px;
      height: 225px;
    }
    &-img-5 {
      margin: @size-extra-medium auto -8px;
      display: block;
      width: 600px;
      height: 380px;
    }
    &-img-6 {
      margin: 52px 0 24px 58px;
      display: block;
      width: 240px;
      height: 64px;
    }
    &-img-7 {
      margin: @size-medium 0 -68px 0;
      display: block;
      width: 100%;
    }
    &-img-8 {
      margin: 90px 0 @size-base @size-large;
      display: block;
      width: 247px;
      height: 64px;
    }
    &-img-9 {
      margin: 47px auto 45px;
      display: block;
      width: 562px;
      height: 430px;
    }
    &-img-10 {
      margin: 80px 474px 24px 56px;
      display: block;
      width: 218px;
      height: 64px;
    }
    &-img-11 {
      margin-top: @size-medium;
      display: block;
      width: 100%;
    }
    &-img-12 {
      margin: 64px 60px 66px 58px;
      display: block;
      width: 630px;
      height: 578px;
    }
    &-img-13 {
      margin: 0 auto 80px;
      display: block;
      width: 500px;
      height: 534px;
    }
    &-img-14 {
      margin: 44px auto 280px;
      display: block;
      width: 100%;
      height: 1054px;
    }
    &-img-15 {
      margin: 0 auto;
      display: block;
      width: 284px;
      height: 88px;
    }

    &-learn-path {
      &-block {
        position: relative;

        &-content {
          padding-left: 82px;
          color: @color-text-light;
          font-size: @font-size-base;
          line-height: 1.5;
        }
        &-desc {
          box-sizing: border-box;
          padding: 0 55px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: @color-text-base;
          font-size: @font-size-small;
          line-height: 1.5;
        }
        &-link-more {
          position: relative;
          z-index: @z-index-large;
          flex-shrink: 0;
          width: 230px;
          height: 80px;
          margin: 0 @size-large 0 460px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-white;
          font-size: @font-size-base;
          font-weight: @font-weight-bold;
          line-height: 1;
          background: @main-color;
          border-radius: @border-radius-extra-large;

          .img-link {
            margin-left: @size-extra-small;
            display: block;
            width: @size-base;
            height: 24px;
          }

          &.margin-auto {
            margin: 0 0 0 @size-medium;
          }
        }
      }
    }

    &-system-file {
      margin-bottom: 64px;
      &-content {
        box-sizing: border-box;
        padding: 0 74px;
        color: @color-text-light;
        font-size: @font-size-small;
        line-height: 1.5;
      }
    }

    &-recognize {
      &-container {
        position: relative;

        &-content {
          position: absolute;
          bottom: 100px;
          left: 96px;
          width: 564px;
          color: @color-text-light;
          font-size: @font-size-base;
          line-height: 1.5;

          &-deco {
            margin-bottom: 26px;
            width: @size-medium;
            height: @size-extra-small;
            background: @main-color;
            border-radius: @border-radius-base;
          }
        }
      }
    }
  }
</style>
